import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IStopTypology } from 'models/production/stopTopology.model';
import { useHistory } from 'react-router-dom';
import { editStopTopology } from 'services/api/requests/production';

export const useEditStopTopology = (body: IStopTypology, id: number) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation(() => editStopTopology(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries(['tipologiaParadas-list']);
			history.goBack();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Tipologia de parada atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error.response.data.length > 0) {
				toast({
					title: 'Erro ao atualizar tipologia de parada!',
					description: error.response.data[0].message,
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			} else {
				toast({
					title: 'Erro ao atualizar tipologia de parada!',
					description:
						'Ocorreu um erro ao tentar atualizar a tipologia de parada, verifique os dados e tente novamente.',
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			}
		},
	});
};
